import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-add',
	path: '/secure/admin/AddNotification([!%]?[\\w]*).jspa',
};
